import { globalEntitlements } from '../utils/globalEntitlements';

export const BUSINESS_LICENSE_FILING_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.businessLicenseFiling.buyBox.bulletPoint1' },
          { title: 'productPage.businessLicenseFiling.buyBox.bulletPoint2' },
          { title: 'productPage.businessLicenseFiling.buyBox.bulletPoint3' },
          { title: 'productPage.businessLicenseFiling.buyBox.bulletPoint4' },
        ],
        productName: 'productPage.businessLicenseFiling.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.businessLicenseFiling.buyBox.veloCta.prompt',
          topic: 'business-license-filing',
        },
        couponBanner: {
          message: 'productPage.businessLicenseFiling.buyBox.couponBanner',
        },
        interactService: {
          service: 'business_license_filing',
        },
        note: 'productPage.businessLicenseFiling.buyBox.note',
      },
    ],
    headerPicture: {
      src: '/s2/raster/approved-stamp-document.png',
      alt: 'productPage.businessLicenseFiling.heroPicture.altText',
      objectPosition: 'center',
    },
    headline: 'productPage.businessLicenseFiling.page.headline',
    partnerLogo: {
      src: '/s2/vector/partnership-avalara.svg',
      alt: '',
    },
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.businessLicenseFiling.page.headlinePill',
      bgcolor: 'background.orange.light',
    },
    subheader: 'productPage.businessLicenseFiling.page.subheader',
  },
  whyDoINeedThis: {
    title: 'productPage.businessLicenseFiling.whyDoINeedThis.title',
    items: [
      {
        icon: '/s2/material-icons/accesstimerounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle1',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy1',
      },
      {
        icon: '/s2/material-icons/attachmoneyrounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle2',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy2',
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle3',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy3',
      },
    ],
  },
  benefit: {
    title: 'productPage.businessLicenseFiling.whyDoINeedThis.title',
    items: [
      {
        icon: '/s2/material-icons/hourglasstoprounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle1',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy1',
      },
      {
        icon: '/s2/material-icons/attachmoneyrounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle2',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy2',
      },
      {
        icon: '/s2/material-icons/verifieduserrounded.svg',
        title: 'productPage.businessLicenseFiling.whyDoINeedThis.propTitle3',
        description: 'productPage.businessLicenseFiling.whyDoINeedThis.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.businessLicenseFiling.howItWorks.title',
    items: [
      {
        title: 'productPage.businessLicenseFiling.howItWorks.step1',
        description: 'productPage.businessLicenseFiling.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.businessLicenseFiling.howItWorks.step2',
        description: 'productPage.businessLicenseFiling.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.businessLicenseFiling.howItWorks.step3',
        description: 'productPage.businessLicenseFiling.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.businessLicenseFiling.howItWorks.step4',
        description: 'productPage.businessLicenseFiling.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/writing-desk-apron-cafe.png',
    alt: 'productPage.businessLicenseFiling.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  whatsIncluded: {
    title: 'productPage.businessLicenseFiling.whatsIncluded.title',
    items: [
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item1',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item2',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item3',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item3ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item4',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item4ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item5',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item5ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item6',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item6ShortDescription',
      },
      {
        title: 'productPage.businessLicenseFiling.whatsIncluded.item7',
        description: 'productPage.businessLicenseFiling.whatsIncluded.item7ShortDescription',
      },
    ],
    image: '/s2/raster/cleaning-window-gloves.png',
    alt: 'productPage.businessLicenseFiling.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  relatedProducts: {
    title: 'productPage.businessLicenseFiling.relatedProducts.title',
    items: [
      {
        title: 'dashboard.products.business_license_report.title',
        description: 'dashboard.products.business_license_report.description',
        productSlug: 'business-licenses',
        entitlement: 'business_license_report',
      },
      {
        title: 'product.name.worry_free_service_advanced_addon',
        description: 'dashboard.products.worry_free_service_advanced_addon.description',
        productSlug: 'wfc-advanced',
        entitlement: 'worry_free_service_advanced_addon',
      },
      {
        title: 'productPage.businessLicenseFiling.relatedProducts.businessDocumentTemplates.title',
        description: 'dashboard.products.corporate_docs.description',
        productSlug: 'corporate-docs',
        entitlement: 'corporate_docs',
      },
    ],
  },
  assistance: {
    title: 'productPage.businessLicenseFiling.needAssistance.title',
    getInTouch: 'productPage.businessLicenseFiling.needAssistance.getInTouch',
    actions: 'productPage.businessLicenseFiling.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.businessLicenseFiling.buyBox.buttonLabel.notPurchased',
  })
    .businessFormed('productPage.businessLicenseFiling.buyBox.buttonDisabled.tooltip')
    .customCtaTextHasRelatedServices(
      ['business_license_filing'],
      'productPage.businessLicenseFiling.buyBox.buttonLabel.purchased',
    )
    .build(),
};
